import { render } from "./WorksPage.vue?vue&type=template&id=18f3b0fc&scoped=true"
import script from "./WorksPage.vue?vue&type=script&lang=js"
export * from "./WorksPage.vue?vue&type=script&lang=js"

import "./WorksPage.vue?vue&type=style&index=0&id=18f3b0fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18f3b0fc"

export default script